export interface PrepopulateFieldsObj {
  firstName: string;
  lastName: string;
  country: string;
  state: string;
  city: string;
  address1: string;
  address2: string;
  postalCode: string;
  email: string;
  phone: string;
}

class PrepopulateFields {
  creditCardAddress1: string;
  creditCardAddress2: string;
  creditCardCountry: string;
  creditCardState: string;
  creditCardHolderName: string;
  creditCardCity: string;
  creditCardPostalCode: string;
  email: string;
  phone: string;

  constructor({
    firstName,
    lastName,
    country,
    state,
    city,
    address1,
    address2,
    postalCode,
    email,
    phone
  }: PrepopulateFieldsObj) {
    this.creditCardAddress1 = address1;
    this.creditCardAddress2 = address2;
    this.creditCardCountry = country;
    this.creditCardState = state;
    this.creditCardHolderName = `${firstName} ${lastName}`;
    this.creditCardCity = city;
    this.creditCardPostalCode = postalCode;
    this.email = email;
    this.phone = phone;
  }
}

export default PrepopulateFields;
